

<script>
export default {
    methods: {
        stringify: function(value) {
            let result = []
            if(typeof value === 'object') {
                for(let k in value) {
                    if(value.hasOwnProperty(k)) {
                        result.push(`${k}=${value[k]}`)
                    }
                }
            }
            return result.join('&')
        }
    }
}
</script>


// WEBPACK FOOTER //
// UtilMixin.vue?62863de9